import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { isAdminUser } from '@utils/userToken';

export const AdminGuard: FC = () => {
  if (!isAdminUser()) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
